'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useAnalytics } from '@/hooks/useAnalytics';
import { CONTACT_EMAIL } from '@/lib/contact';
import { MailIcon } from '@/components/icons';
export function EmailLink() {
  const $ = _c(8);
  const [copied, setCopied] = React.useState(false);
  const hideTimer = React.useRef(0);
  const {
    track
  } = useAnalytics();
  let t0;
  if ($[0] !== track) {
    t0 = () => {
      navigator.clipboard.writeText(CONTACT_EMAIL);
      setCopied(true);
      track("email_copied", {
        location: "home"
      });
      window.clearTimeout(hideTimer.current);
      hideTimer.current = window.setTimeout(() => setCopied(false), 2000);
    };
    $[0] = track;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const copyEmail = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MailIcon className="size-[22px] text-zinc-500 transition group-hover:text-zinc-600 dark:text-zinc-400 dark:group-hover:text-zinc-300" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `ease-out-strong absolute top-1/2 left-8 -translate-y-1/2 text-sm whitespace-nowrap text-zinc-600 transition-[opacity,transform] duration-300 dark:text-zinc-400 ${copied ? "translate-x-0 opacity-100" : "-translate-x-2 opacity-0"} `;
  let t3;
  if ($[3] !== t2) {
    t3 = <div className={t2}>Copied to clipboard!</div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== copyEmail || $[6] !== t3) {
    t4 = <button type="button" onClick={copyEmail} aria-label="Copy email to clipboard" className="group relative -m-1 rounded-sm p-1 focus-visible:ring-2 focus-visible:ring-teal-500 focus-visible:ring-offset-2 focus-visible:outline-none">{t1}{t3}</button>;
    $[5] = copyEmail;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}